import { action } from 'typesafe-actions';
import { IGasState } from '../core/BlocksSubscription';

const entity = 'blockchains';
const ACTION_ETH_BLOCK = `${entity}/ETH_BLOCK`;
const ACTION_BSC_BLOCK = `${entity}/BSC_BLOCK`;
const ACTION_POLYGON_BLOCK = `${entity}/POLYGON_BLOCK`;
const ACTION_GAS_PRICE = `${entity}/GAS`;

const actionEthBlockMined = (block: number) =>
  action(ACTION_ETH_BLOCK, block);

const actionBscBlockMined = (block: number) =>
  action(ACTION_BSC_BLOCK, block);

const actionPolygonBlockMined = (block: number) =>
  action(ACTION_POLYGON_BLOCK, block);

const actionGasPrice = (gas: IGasState) =>
  action(ACTION_GAS_PRICE, gas);

export {
  ACTION_ETH_BLOCK,
  ACTION_BSC_BLOCK,
  ACTION_POLYGON_BLOCK,
  ACTION_GAS_PRICE,
  actionEthBlockMined,
  actionBscBlockMined,
  actionPolygonBlockMined,
  actionGasPrice
};